import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aad30c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "v-btn__leftIcon"
}
const _hoisted_2 = {
  key: 1,
  class: "v-btn__rightIcon"
}
const _hoisted_3 = {
  key: 2,
  class: "v-btn__warning"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11.5",
    cy: "11.5",
    r: "11.5",
    fill: "#F4C7CF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.705 5.99609H10.29L10.77 12.96H12.225L12.705 5.99609ZM10.32 15.0082C10.32 15.6297 10.845 16.1241 11.49 16.1241C12.15 16.1241 12.69 15.6297 12.69 15.0082C12.69 14.3866 12.15 13.8781 11.49 13.8781C10.845 13.8781 10.32 14.3866 10.32 15.0082Z",
    fill: "#252525"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]

import BaseIcon from './BaseIcon.vue'
import { withDefaults, useSlots, ref, computed } from 'vue'

interface Props {
  block?: boolean
  disabled?: boolean
  loading?: boolean
  text?: boolean
  leftIcon?: string
  rightIcon?: string
  theme?: string
  wide?: boolean
  outline?: boolean
  warning?: boolean
  textColor?: string
  activeTime?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    leftIcon: { default: '' },
    rightIcon: { default: '' },
    theme: { default: 'primary' },
    wide: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    warning: { type: Boolean, default: false },
    textColor: { default: '' },
    activeTime: { default: 100 }
  },
  emits: ['click'],
  setup(__props: any, { expose, emit }) {

const props = __props as { block: boolean, disabled: boolean, loading: boolean, text: boolean, leftIcon: string, rightIcon: string, theme: string, wide: boolean, outline: boolean, warning: boolean, textColor: string, activeTime: number }

const availableThemes = ['white', 'black', 'primary']



const slots = useSlots()


// missing validators
// defineProps<Props>() does not support validators, need to use defineProps({...}) to get that working
// value => availableThemes.includes(value) }) readonly theme!: string
// value => nativeTypes.includes(value) }) readonly nativeType!: string
// value => availableTags.includes(value) }) readonly tag!: string

const active = ref(false)

const buttonClasses = computed(() => {
  return {
    'v-btn': true,
    [`v-btn--${props.theme}`]: props.theme,
    'v-btn--block': props.block,
    'v-btn--disabled': props.disabled,
    'v-btn--loading': props.loading,
    'v-btn--outlined': props.outline,
    'v-btn--text': props.text,
    'v-btn--right_icon': hasRightIcon(),
    'v-btn--left_icon': hasLeftIcon(),
    'v-btn--wide': props.wide,
    'v-btn--active': active.value
  }
})

const hasLeftIcon = () => {
  return !!props.leftIcon || !!slots['left-icon']
}

const hasRightIcon = () => {
  return !!props.rightIcon || !!slots['right-icon']
}

const hasWarning = () => {
  return !!props.warning
}

const clickedButton = (event: any) => {
  if (active.value) {
    return
  }
  active.value = true
  window.setTimeout(() => {
    active.value = false
  }, props.activeTime)

  emit('click', event)
}

const getTextColor = () => {
  if (props.textColor && props.textColor !== '') {
    return 'color: ' + props.textColor
  } else {
    return ''
  }
}

expose({ clickedButton })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_unref(buttonClasses)),
    "data-clickable": "true",
    onClick: clickedButton
  }, [
    (hasLeftIcon())
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "left-icon", {}, () => [
            _createVNode(BaseIcon, {
              width: "18",
              height: "18",
              "icon-name": __props.leftIcon,
              color: props.textColor
            }, null, 8, ["icon-name", "color"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "v-btn__slot",
      style: _normalizeStyle(getTextColor())
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    (hasRightIcon())
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "right-icon", {}, () => [
            _createVNode(BaseIcon, {
              width: "18",
              height: "18",
              "icon-name": __props.rightIcon
            }, null, 8, ["icon-name"])
          ])
        ]))
      : _createCommentVNode("", true),
    (hasWarning())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ], 2))
}
}

})